export default "__VITE_ASSET__CMGhmrCA__"